import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BankAccountsService {
  url = environment.api;

  constructor(private http: HttpClient) {}

  filterBankAccounts(currencyId: any) {
    const scid = localStorage.getItem('scid');
    const path = `${this.url}/api/v1/bankaccounts/filter`;
    const body = {
      serviceCenterId: scid,
      currencyId: currencyId,
    };
    return this.http.post(path, body);
  }
}
